$(document).ready(function () {
    var swiper = new Swiper(".swiper", {
        spaceBetween: 0,
        direction: "horizontal",
        slidesPerView: 1,
        noSwiping: false,
        loop: true,
        autoplay: {
            delay: 2000,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },  
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
    });


    initSection();
    initBeef();
    initPork();
    initLamb();
    initPoultry();
    initCharc();

    scrollToSection();
    activeLink();
    clickProductItem();
    scrollPrev();
    scrollNext();
    checkOverflow();
});

$(window).resize( function() {
    $('.beef .meat-navi .nav-item').first().click();
    $('.pork .meat-navi .nav-item').first().click();
    $('.lamb .meat-navi .nav-item').first().click();
    $('.poultry .meat-navi .nav-item').first().click();
    $('.charcuterie .meat-navi .nav-item').first().click();
    checkOverflow();
});

function initBeef() {
    meatNavi($('.beef .meat-navi .nav-item'));
    naviScroll($('.beef .meat-navi .wrapper'));
}

function initPork() {
    meatNavi($('.pork .meat-navi .nav-item'));
    naviScroll($('.pork .meat-navi .wrapper'));
}

function initLamb() {
    meatNavi($('.lamb .meat-navi .nav-item'));
    naviScroll($('.lamb .meat-navi .wrapper'));
}

function initPoultry() {
    meatNavi($('.poultry .meat-navi .nav-item'));
    naviScroll($('.poultry .meat-navi .wrapper'));
}

function initCharc() {
    meatNavi($('.charcuterie .meat-navi .nav-item'));
    naviScroll($('.charcuterie .meat-navi .wrapper'));
}

function naviScroll($elem) {
    $elem.scroll( function() {
        var navItem = $(this).find('.nav-item.active');
        var height = navItem.height() + 10;
        var width = navItem.width() + 40;
        var left = navItem.position().left - 20;
        // var navBorder = $(this).find('.nav-indication');
        // navBorder.css({
        //     'height': height,
        //     'width': width,
        //     'left': left
        // });

    });
}

function meatNavi($elem) {
    $elem.on('click', function () {
        var height = $(this).height() + 10;
        var width = $(this).width() + 40;
        var index = $(this).data('index');
        var left = $(this).offset().left - 20;
        if ($(this).hasClass('active')) {
            return;
        }
        $(this).addClass('active');
        $(this).siblings().removeClass('active');
        // var navItem = $(this).closest('.meat-navi').find('.nav-indication');
        // navItem.css({
        //     'height': height,
        //     "width": width,
        //     "left": left
        // });

        var $container = $(this).closest('.meat-container').find(`.meat-info-wrapper[data-index="${index}"]`);
        var $siblings = $(this).closest('.meat-container').find('.meat-info-wrapper').hide();
        $siblings.hide();
        $container.css('display', 'flex');
    });
    $elem.first().click();
}

function scrollToSection() {
    $('.our-products .bottom-part .product').click( function() {
        var section = $(this).attr('href').replace('#', '');
        if (section.length < 1) {
            console.log(section);
            return;
        }
        var pos = $(`.meat-container.${section}`).offset().top;
        window.scrollTo({
            top: pos,
            left: 0,
            behavior: 'smooth'
        });
        $(`.menu-dropdown .product.link-${section}`).addClass('active');
        $(`.menu-dropdown .product.link-${section}`).siblings().removeClass('active');
    });
}

function clickProductItem() {
    $('.fs-header .products-dropdown .product').click( function() {
        var section = $(this).attr('href').split('#');
        section = section[1];
        if (typeof(section) == 'undefined') {
            console.log(section);
            return;
        }
        var pos = $(`.meat-container.${section}`).offset().top;
        window.scrollTo({
            top: pos,
            left: 0,
            behavior: 'smooth'
        });
        $(`.menu-dropdown .product.link-${section}`).addClass('active');
        $(`.menu-dropdown .product.link-${section}`).siblings().removeClass('active');
    });
}

function initSection() {
    var section = window.location.href.split('#')[1];
    if (typeof(section) == 'undefined') {
        return;
    }
    var pos = $(`.meat-container.${section}`).offset().top;
    window.scrollTo({
        top: pos,
        left: 0
    });
}

function activeLink() {
    var url = window.location.href;
    var activeLink = url.split('#');
    activeLink = activeLink[1];
    if (typeof(section) == 'undefined') {
        return;
    }
    $(`.menu-dropdown .product.link-${activeLink}`).addClass('active');

}

function scrollPrev() {
    $('.meat-navi .prev').click( function() {
        var navi = $(this).closest('.meat-navi').find('.wrapper');
        var left = navi.scrollLeft() - 100;
        navi.animate({
            scrollLeft: left
        }, 300);

    })
}

function scrollNext() {
    $('.meat-navi .next').click( function() {
        var navi = $(this).closest('.meat-navi').find('.wrapper');
        $(this).closest('.meat-navi').find('.button.prev').addClass('slide-in');
        var right = navi.scrollLeft() + 100;
        navi.animate({
            scrollLeft: right
        }, 300);

    });

    $('.meat-navi .wrapper').scroll( function() {
        if ($(this).scrollLeft() > 20) {
            $(this).closest('.meat-navi').addClass('slide-in')
        }
    })
}

function checkOverflow() {
    $('.meat-navi .wrapper').each( function() {
        var containerWidth = $(this).width();
        var scrollWidth = $(this).prop('scrollWidth');
        if (scrollWidth > containerWidth) {
            $(this).closest('.meat-navi').find('.button.next').show();
            return;
        }

        $(this).closest('.meat-navi').find('.button.next').hide();
    })
}